/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import ReportFilters from '../../../components/ReportFilters/ReportFilters';
import defaultFilters from '../../../components/ReportFilters/utils/defaultFilters';
import PrepareTable from '../../../components/PrepareTable';
import TableConfig from './TableConfig';

function DailyWorkloadTable(props) {
    const { preloader } = props;
    const [queryParams, setQueryParams] = useState();
    const preparQueryParams = async (filters) => {
        const columns = TableConfig();
        const params = {
            columns: columns.columns,
            filters: filters || defaultFilters(),
            url: '/api/reports/build',
            type: 'dailyWorkloadReport',
        };
        setQueryParams(params);
    };

    useEffect(() => {
        preparQueryParams();
    }, []);

    console.log(queryParams);

    return (queryParams ? (
        <>
            <ReportFilters
                showFilters={{
                    main: ['reportRange'],
                    others: [],
                    orders: [],
                }}
                paramsCallback={preparQueryParams}
                type="dailyWorkloadReport"
            />

            <PrepareTable
                keys="date_only"
                type="dailyWorkloadTable"
                {...queryParams}
                preloader={preloader}
            />
        </>
    ) : null);
}

export default DailyWorkloadTable;
